import {SET_MAIN_SCROLL_REF} from 'constants/action-types.js';
import {SET_PRESENTATION_MODE} from 'constants/action-types.js';
import {SET_CABLE_SEGMENTATION} from 'constants/action-types.js';
import {SET_LEFT_SIDEBAR_WIDTH} from 'constants/action-types.js';
import {SET_CABLE_SEGMENTATIONS} from 'constants/action-types.js';
import {SET_VIEWPORT_POSITION} from 'constants/action-types.js';
import {SET_SHOW_MODULATORS} from 'constants/action-types.js';
import {SET_SIDEBARS_SHOWING} from 'constants/action-types.js';
import {SET_SHOW_PAD_SEQUENCER} from 'constants/action-types.js';
import {SET_SHOW_PROJECTS_MODAL} from 'constants/action-types.js';
import {SET_SHOW_SEARCH_WINDOW} from 'constants/action-types.js';
import {SET_SHOW_TRACK_INSTRUMENT} from 'constants/action-types.js';
import {SET_UX_LOCK_OBJECT} from 'constants/action-types.js';
import {SET_UX_LOCK_OBJECTS} from 'constants/action-types.js';
import {SET_UX_HIDE_OBJECT} from 'constants/action-types.js';
import {SET_UX_HIDE_OBJECTS} from 'constants/action-types.js';
import {SET_ZOBJECT_INPUT_TEXT} from 'constants/action-types.js';
import {SET_SHOW_EDITOR_BOTTOM} from 'constants/action-types.js';
import {SET_EDITOR_PADDING} from 'constants/action-types.js';
import {SET_EDGES_PADDING} from 'constants/action-types.js';
import {SET_EDGES_SIZE} from 'constants/action-types.js';

let initialState = {
    editorPadding: {x:1, y:1},
    edgesPadding: {x:0, y:0},
    edgesSize: {width:1200, height:1200},
    position: {x: 0, y: 0},
    sidebarsShowing: true,
    showPadSequencer: undefined,
    showProjectsModal: undefined,
    showSearchWindow: false,
    cableSegmentations: {},
    lockedObjects: {},
    hiddenObjects: {},
    showEditorBottom: false,
    leftSidebarWidth: 50,
    presentationMode: false,
};
    
export default (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_LEFT_SIDEBAR_WIDTH:
        return {
            ... state,
            leftSidebarWidth: action.payload
        };
    case SET_EDITOR_PADDING:
        return {
            ... state,
            editorPadding: action.payload
        };
    case SET_EDGES_PADDING:
        return {
            ... state,
            edgesPadding: action.payload
        };
    case SET_EDGES_SIZE:
        return {
            ... state,
            edgesSize: action.payload
        };
    case SET_SHOW_EDITOR_BOTTOM:
        return {
            ... state,
            showEditorBottom: action.payload
        };
    case SET_ZOBJECT_INPUT_TEXT:
        return {
            ... state,
            zobjectInputText: action.payload
        };
    case SET_CABLE_SEGMENTATION:
        let {cableSegmentations} = state;
        cableSegmentations[action.payload.id] = action.payload.segmentation;
        return {
            ... state,
            cableSegmentations
        };
    case SET_PRESENTATION_MODE:
        return {
            ... state,
            presentationMode: action.payload
        };
    case SET_CABLE_SEGMENTATIONS:
        return {
            ... state,
            cableSegmentations: action.payload
        };
    case SET_SHOW_PAD_SEQUENCER:
        return {
            ... state,
            showPadSequencer: action.payload
        };
    case SET_SHOW_MODULATORS:
        return {
            ... state,
            showModulators: action.payload
        };
    case SET_SHOW_TRACK_INSTRUMENT:
        return {
            ... state,
            showTrackInstrument: action.payload
        };
    case SET_SHOW_PROJECTS_MODAL:
        return {
            ... state,
            showProjectsModal: action.payload
        };
    case SET_MAIN_SCROLL_REF:
        return {
            ... state,
            mainScrollRef: action.payload
        };
    case SET_VIEWPORT_POSITION:
        return {
            ... state,
            position: action.payload
        };
    case SET_SIDEBARS_SHOWING:
        return {
            ... state,
            sidebarsShowing: action.payload
        };
    case SET_SHOW_SEARCH_WINDOW:
        return {
            ... state,
            showSearchWindow: action.payload
        };
    case SET_UX_LOCK_OBJECT:
        let lockedObjects = state.lockedObjects;
        lockedObjects[action.payload.id] = action.payload.lock;
        return {
            ... state,
            lockedObjects
        };
    case SET_UX_LOCK_OBJECTS:
        return {
            ... state,
            lockedObjects: action.payload
        };
    case SET_UX_HIDE_OBJECT:
        let hiddenObjects = state.hiddenObjects;
        hiddenObjects[action.payload.id] = action.payload.hide;
        return {
            ... state,
            hiddenObjects
        };
    case SET_UX_HIDE_OBJECTS:
        return {
            ... state,
            hiddenObjects: action.payload
        };
    default:
        return state;
    }
};

